/** Only call for a successful authorized customer-link response. Never fetch its origin. */
export function customerSharePageUrl(
  canonicalUrl: string,
  applicationUrl: string,
): string {
  const canonical = new URL(canonicalUrl);
  const match = canonical.pathname.match(
    /^\/api\/v1\/public\/shares\/([^/]+)$/,
  );
  if (
    !['http:', 'https:'].includes(canonical.protocol) ||
    canonical.username ||
    canonical.password ||
    canonical.search ||
    canonical.hash ||
    !match
  )
    throw new Error('服务端固定链接格式无效');
  const token = decodeURIComponent(match[1]);
  if (!/^[A-Za-z0-9_-]+$/.test(token))
    throw new Error('服务端固定链接令牌无效');
  const app = new URL(applicationUrl);
  return `${app.origin}${app.pathname}#share/${encodeURIComponent(token)}`;
}

export function readPublicShareToken(hash: string): string | null {
  const match = hash.match(/^#share\/([^/?#]+)$/);
  if (!match) return null;
  try {
    const token = decodeURIComponent(match[1]);
    return /^[A-Za-z0-9_-]+$/.test(token) ? token : '';
  } catch {
    return '';
  }
}
